import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				borderRadius: 4,
				marginBottom: 5,
				alignItems: "center",
				justifyContent: "space-between"
			},
			customImage: {
				display: "flex",
				alignItems: "center",
				"& > img": {
					width: 53,
					height: 53,
					marginRight: 5,
					padding: 5,
					borderRadius: 3,
					objectFit: "contain",
					background: theme.palette.common.white
				}
			},
			name: {
				fontSize: 12,
				color: theme.palette.primary.contrastText,
				fontWeight: 500
			},
			quantity: {
				width: 100,
				fontSize: 13,
				color: theme.palette.primary.contrastText,
				display: "flex",
				justifyContent: "space-between",
				fontWeight: 500
			}
		}),
	{
		name: "PromotionItem",
		index: 1
	}
);

export default useStyles;
